import { Form, Formik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { IoFilterSharp } from "react-icons/io5";
import { LiaTimesSolid } from "react-icons/lia";
import { toast } from "react-toastify";
import * as yup from "yup";
import { ERROR_MSG, ROLE } from "../../../constants/common";
import {
    RESET_LOADER,
    SET_ERROR,
    SET_LOADER,
} from "../../../constants/contexConstant";
import {
    GET_ADMIN_REMINDER_API,
    GET_HYPERSROT_MEMBERS_API,
    GET_REMINDER_ADMIN_SUMMARY,
    GET_REMINDER_SALES_SUMMARY,
    RESOLVE_REMINDER_SALES_ENDPOINT,
} from "../../../constants/routes";
import { useContextState } from "../../../context/ContextProvider";
import { checkIsAllowed } from "../../../helpers/helpers";
import useNetwork from "../../../hooks/useNetwork";
import cn from "../../../lib/cn";
import request from "../../../services/request";
import Container from "../../../shared/Container";
import Section from "../../../shared/Section";
import P from "../../../shared/typography/P";
import Button from "../../../shared/ui/Button";
import BottomDrawer from "../../../shared/ui/Drawer/BottomDrawer";
import LabeledFormikSelect from "../../../shared/ui/Form/LabeledFormikSelect";
import Info from "../../../shared/ui/Info";
import LinedTab from "../../../shared/ui/tab/LinedTab";
import ReminderCard from "./ReminderCard";
const filterButtonStyle =
    "bg-gray-200 px-1 py-0.2 text-sm rounded flex items-center gap-0.5";

const Reminders = () => {
    const [currentTab, setCurrentTab] = useState(0);
    const [filterOptions, setFilterOptions] = useState({
        duration: "",
        assignee: "",
    });
    const [isOpen, setIsOpen] = useState(false);
    const [reminderList, setReminderList] = useState([]);
    const [todaysReminder, setTodaysReminder] = useState([]);
    const { state, dispatch } = useContextState();
    let [assignees, setAssignees] = useState([]);

    const isAdmin = checkIsAllowed(state?.user?.roles, [ROLE.SUPER_ADMIN]);
    const summaryPath = isAdmin
        ? GET_REMINDER_ADMIN_SUMMARY
        : GET_REMINDER_SALES_SUMMARY;

    const { data: summary } = useNetwork(summaryPath);

    useEffect(() => {
        const getMembers = async () => {
            try {
                dispatch({ type: SET_LOADER });
                let res = await request.authGet({
                    endpoint: GET_HYPERSROT_MEMBERS_API,
                });
                let response = res?.data?.members;
                if (response) {
                    setAssignees(
                        response.map((item) => ({
                            label: item.name,
                            value: item.id,
                        }))
                    );
                }
                dispatch({ type: RESET_LOADER });
            } catch (error) {
                dispatch({ type: RESET_LOADER });
                dispatch({
                    type: SET_ERROR,
                    payload: typeof error === "string" ? error : ERROR_MSG,
                });
            }
        };

        if (isAdmin) {
            getMembers();
        }
    }, [dispatch, isAdmin]);

    const getTodaysReminders = useCallback(
        async (duration = null, assignee = null) => {
            let params = new URLSearchParams();
            if (duration) params.append("duration", duration);
            if (assignee) params.append("assigneeId", assignee);

            if (
                duration === filterOptions.duration &&
                assignee === filterOptions.assignee
            )
                return;

            let queryString =
                params.toString() !== "" ? `&${params.toString()}` : "";
            try {
                dispatch({ type: SET_LOADER });
                let res = await request.authGet({
                    endpoint: `${GET_ADMIN_REMINDER_API}?isForToday=false${queryString}`,
                });
                setTodaysReminder(res?.data?.reminders);
                dispatch({ type: RESET_LOADER });
            } catch (error) {
                dispatch({ type: RESET_LOADER });
                dispatch({
                    type: SET_ERROR,
                    payload: typeof error === "string" ? error : ERROR_MSG,
                });
            }
        },
        [dispatch, filterOptions.assignee, filterOptions.duration]
    );

    useEffect(() => {
        getTodaysReminders("7D");
    }, []);

    const handleTabClick = (val) => {
        setCurrentTab(val);
    };

    const handleSubmit = (values, actions) => {
        setIsOpen(false);
        getTodaysReminders(values.duration, values.assignee, false);
        setFilterOptions(values);
    };

    const remindersSummaryData = summary?.data?.data || {};

    const handleResolve = async (id) => {
        try {
            dispatch({ type: SET_LOADER });

            await request.authPut({
                endpoint: `${RESOLVE_REMINDER_SALES_ENDPOINT}/${id}`,
            });

            setReminderList(
                reminderList.map((item) =>
                    item.id === id ? { ...item, status: "RESOLVED" } : item
                )
            );

            setTodaysReminder(
                todaysReminder.map((item) =>
                    item.id === id ? { ...item, status: "RESOLVED" } : item
                )
            );
            toast.success("Reminder resolved");
            dispatch({ type: RESET_LOADER });
        } catch (error) {
            dispatch({ type: RESET_LOADER });
            dispatch({
                type: SET_ERROR,
                payload: typeof error === "string" ? error : ERROR_MSG,
            });
        }
    };

    const clearFilters = (key) => {
        let existingFilters = { ...filterOptions };
        existingFilters[key] = "";
        getTodaysReminders(existingFilters.duration, existingFilters.assignee);
        setFilterOptions(existingFilters);
    };
    return (
        <Section className=" bg-white mb-0 pb-6">
            <div className="min-h-[128px] bg-blue-700"></div>
            <div className="pt-2 rounded-3 bg-white -mt-3">
                <Container>
                    <div className="bg-linear-blue-white rounded-sm shadow-md p-1.5 mb-2 ">
                        <div className="flex justify-center items-center gap-1 text-center bg-gray-100 rounded-full py-0.5 mb-2">
                            <P className="text-xs font-vietnam">
                                Total Reminder
                            </P>
                            <P className="text-base font-vietnam">
                                {remindersSummaryData
                                    ? remindersSummaryData?.todaysReminders +
                                      remindersSummaryData?.oldReminders
                                    : 0}
                            </P>
                        </div>

                        <div className="flex justify-between items-center">
                            <div className="text-center">
                                <P className="text-base font-vietnam text-gray-100">
                                    {remindersSummaryData?.todaysReminders || 0}
                                </P>
                                <P className="text-xs font-vietnam text-gray-100">
                                    Today's Reminder
                                </P>
                            </div>
                            <div className="h-auto w-0.1 bg-green-200"></div>
                            <div className="text-center">
                                <P className="text-base font-vietnam text-gray-100">
                                    {remindersSummaryData?.oldReminders || 0}
                                </P>
                                <P className="text-xs font-vietnam text-gray-100">
                                    Old Reminder
                                </P>
                            </div>
                        </div>
                    </div>

                    <div className="flex items-center mb-1.5 gap-2 border-b border-b-blue-200">
                        <LinedTab
                            className="pb-0  mt-0 pt-0 w-full "
                            activeClass={
                                "text-blue font-medium duration-300 w-[100px]"
                            }
                            inActiveClass={"text-gray-370 w-[100px]"}
                            data={["Reminders"]}
                            activeTab={currentTab}
                            onClick={handleTabClick}
                        />

                        <button
                            onClick={() => setIsOpen((prev) => !prev)}
                            className="text-xxl"
                        >
                            <IoFilterSharp />
                        </button>
                    </div>
                    <div
                        className={cn("flex gap-1", {
                            "pb-1.5":
                                filterOptions.assignee ||
                                filterOptions.duration,
                        })}
                    >
                        {filterOptions.assignee && (
                            <button
                                onClick={() => clearFilters("assignee")}
                                className={filterButtonStyle}
                            >
                                {
                                    assignees.find(
                                        (item) =>
                                            item.value ===
                                            filterOptions.assignee
                                    ).label
                                }
                                <LiaTimesSolid />
                            </button>
                        )}
                        {filterOptions.duration && (
                            <button
                                onClick={() => clearFilters("duration")}
                                className={filterButtonStyle}
                            >
                                {filterOptions.duration}
                                <LiaTimesSolid />
                            </button>
                        )}
                    </div>
                    {todaysReminder?.length > 0 ? (
                        todaysReminder
                            .sort((a, b) => b?.date - a?.date)
                            .map((reminder, index) => (
                                <ReminderCard
                                    onClick={handleResolve}
                                    key={index}
                                    {...reminder}
                                />
                            ))
                    ) : (
                        <Info message="No Reminders Available" />
                    )}
                </Container>
            </div>

            <BottomDrawer
                isOpen={isOpen}
                onClick={() => setIsOpen((prev) => !prev)}
                contentClass="min-h-[60vh] rounded-t-4 bg-white"
                childrenClassName="bg-white"
            >
                <Container>
                    <Formik
                        initialValues={filterOptions}
                        validationSchema={yup.object().shape({
                            duration: yup.string(),
                            assignee: yup.string(),
                        })}
                        onSubmit={handleSubmit}
                    >
                        {() => (
                            <Form>
                                <div className="  pt-2 pb-8  flex flex-col gap-y-2 ">
                                    <P className="text-primary text-sm font-vietnam">
                                        Filter By:
                                    </P>

                                    <LabeledFormikSelect
                                        name="duration"
                                        label="Date Range"
                                        options={filterDuration}
                                    />
                                    {isAdmin && (
                                        <LabeledFormikSelect
                                            name="assignee"
                                            label="Assignee Name"
                                            options={assignees}
                                        />
                                    )}
                                    <Button
                                        type="submit"
                                        className="bg-primary"
                                    >
                                        Apply Filter
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Container>
            </BottomDrawer>
        </Section>
    );
};

export default Reminders;

let filterDuration = [
    {
        label: "Today",
        value: "1D",
    },
    {
        label: "7 Days",
        value: "7D",
    },
    {
        label: "30 Days",
        value: "30D",
    },
    {
        label: "1 Year",
        value: "365D",
    },
    {
        label: "Lifetime",
        value: "lifetime",
    },
];
